import { render, staticRenderFns } from "./GiftBar.vue?vue&type=template&id=13ab79be"
import script from "./GiftBar.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftBar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports